<template>
    <v-main id="tableAgentComm">
        <v-container class="pa-0 px-1" fluid>
            <v-card class="pa-2">
                <v-card-title class="pt-0 pb-0 justify-center">Overview of agent commission values</v-card-title>
                <v-divider></v-divider>
                <v-row class="mb-2">
                    <v-col cols="11"><v-text-field v-model="search" label="Search" single-line hide-details prepend-icon="mdi-magnify"></v-text-field></v-col>
                    <v-col cols="1"><btn_excel_export :cols="cols" :data="data" name="Agent_Commission_Overview.xlsx" sheet="Commission" /></v-col>
                </v-row>
                <v-data-table 
                    :items="data" 
                    :items-per-page="20" 
                    :footer-props="{'items-per-page-options': [20, 50, 100, 500, -1]}"
                    :headers="headers"
                    :search="search"
                    dense>
                    <template v-slot:item="agent_acco">
                        <tr>
                            <td>{{ agent_acco.item.gebr_code }}</td>
                            <td>{{ agent_acco.item.gebr_naam }}</td>
                            <td @click="$router.open('/huis/onHuis/' + agent_acco.item.huis_encrid)"><a>{{ agent_acco.item.huis_code }}</a></td>
                            <td>{{ agent_acco.item.hsct_agtn_com_start_dat }}</td>
                            <td>{{ agent_acco.item.hsct_agtn_perc_kosten_aandeel }}</td>
                            <td>{{ agent_acco.item.hsct_agtn_schaal_jaar1 }}</td>
                            <td>{{ agent_acco.item.hsct_agtn_schaal_jaar2 }}</td>
                            <td>{{ agent_acco.item.hsct_agtn_schaal_jaar3 }}</td>
                            <td>{{ agent_acco.item.hsct_agtn_schaal_jaar4 }}</td>
                            <td>{{ agent_acco.item.hsct_agtn_schaal_jaar5 }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
        <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
    </v-main>
</template>
  
<script>
    import btn_excel_export from "@/components/ui/buttons/btn_excel_export.vue";
    import navBar from "@/components/ui/navbars/navbar.vue";

    export default {
        components: {
            btn_excel_export,
            navBar,
        },
        data() {
            return {
                data: [],
                search: "",
                headers: [
                    {text: 'Agent code', value: 'gebr_code'},
                    {text: 'Agent naam', value: 'gebr_naam'},
                    {text: 'Accommodation', value: 'huis_code'},
                    {text: 'Commission start', value: 'hsct_agtn_com_start_dat'},
                    {text: 'Percentage costs part', value: 'hsct_agtn_perc_kosten_aandeel'},
                    {text: 'scale year 1', value: 'hsct_agtn_schaal_jaar1'},
                    {text: 'scale year 2', value: 'hsct_agtn_schaal_jaar2'},
                    {text: 'scale year 3', value: 'hsct_agtn_schaal_jaar3'},
                    {text: 'scale year 4', value: 'hsct_agtn_schaal_jaar4'},
                    {text: 'scale year 5', value: 'hsct_agtn_schaal_jaar5'},
                ],      
                cols: [
                    {Name: 'Agent code', Type: "Text", Field: 'gebr_code'},
                    {Name: 'Agent naam', Type: "Text", Field: 'gebr_naam'},
                    {Name: 'Accommodation', Type: "Text", Field: 'huis_code'},
                    {Name: 'Commission start', Type: "Text", Field: 'hsct_agtn_com_start_dat'}, 
                    {Name: 'Percentage costs part', Type: "Number", Field: 'hsct_agtn_perc_kosten_aandeel'},
                    {Name: 'scale year 1', Type: "Number", Field: 'hsct_agtn_schaal_jaar1'},
                    {Name: 'scale year 2', Type: "Number", Field: 'hsct_agtn_schaal_jaar2'},
                    {Name: 'scale year 3', Type: "Number", Field: 'hsct_agtn_schaal_jaar3'},
                    {Name: 'scale year 4', Type: "Number", Field: 'hsct_agtn_schaal_jaar4'},
                    {Name: 'scale year 5', Type: "Number", Field: 'hsct_agtn_schaal_jaar5'},
                ]      
            }
        },
        mounted() {
            this.$axios.post("ares/json/ares/task/fin/ovrz/getAgentCommission.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getAgentCommission"
                },
                getAgentCommission: {

                },
            }).then(res => {
                if (res.data.error) {
                    // console.log(res.data.error);
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: res.data.error.message,
                        color: "error",
                    });
                } else {
                    this.data = res.data.getAgentCommission; 
                }
            }); 
        },
        methods: {
        }
    };
</script>

